import { Box, Collapse, Fade } from '@mui/material';
import type { ReactNode, Ref } from 'react';

const ANIMATION_MS = 400;

interface Props {
    show?: boolean;
    stepRef?: Ref<HTMLDivElement>;
    children: ReactNode;
}

export default function NewProspectAnimatedStep({ show = true, stepRef, children }: Props) {
    return (
        <Collapse in={show} unmountOnExit timeout={ANIMATION_MS}>
            <Fade in={show} appear timeout={ANIMATION_MS}>
                <Box ref={stepRef}>{children}</Box>
            </Fade>
        </Collapse>
    );
}
